module.exports = __webpack_public_path__ + "img/video.df99a2e7.svg";